import React from 'react';
import { FaCheck } from 'react-icons/fa';

const ProjectWizard = ({ currentStep, steps }) => (
    // <div className="wizard-container">
    //     <div className="step-indicator-wrapper">
    //         <div className="step-progress-track"></div>
    //         <div className="step-progress-fill" style={{ width: `${(currentStep / (steps.length - 1)) * 92}%` }}></div>
    //         {steps.map((step, index) => (
    //             <div key={step.id} className={`step-item ${index === currentStep ? 'active' : ''} ${index < currentStep ? 'completed' : ''}`}>
    //                 <div className="step-circle">{index < currentStep ? <FaCheck /> : index + 1}</div>
    //                 <div className="step-label">{step.title}</div>
    //             </div>
    //         ))}
    //     </div>
    // </div>
    <div className="wizard-stepper-container">
           

        {steps.map((step, index) => (
            <div key={step.id} className={`step-item ${index === currentStep ? 'active' : ''} ${index < currentStep ? 'completed' : ''}`} style={{ cursor: (index + 1 < currentStep) ? 'pointer' : 'default' }}>
                <div className="step-circle">{index < currentStep ? <FaCheck /> : index + 1}</div>
                <div className="step-label">{step.title}</div>
            </div>
        ))}
    </div>
);

export default ProjectWizard;